var exports = {
  "holder": "x0a7806d5--0e0a5c--holder",
  "container": "x0a7806d5--0e0a5c--container",
  "fixed-in": "x0a7806d5--0e0a5c--fixed-in",
  "appear": "x0a7806d5--0e0a5c--appear",
  "fixed-out": "x0a7806d5--0e0a5c--fixed-out",
  "disappear": "x0a7806d5--0e0a5c--disappear",
  "content": "x0a7806d5--0e0a5c--content",
};

module.exports = exports;
